import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Modal from "sushiweb/Modal";
import { FlexContainer } from "../../../constants/assets/containers";
import AllPagesPdf from "../AllPagesPdf";
import DownloadLink from "../DownloadLink";
import Download from "sushiweb/Icons/all/Download";
import variables from "../../../constants/assets/variables";

const DriverDocumentModal = ({
  showModal,
  handleClose,
  pdf,
  modalContent,
  optionalInput,
  optionalPhotoUrl,
  primaryPhotoTitle,
  fullWidthModal,
  optionalPhotoTitle,
  infoFields
}) => {
  const imgRef = useRef(null);
  const [coords, setCoords] = useState({});
  const [initialCoords, setInitialCoords] = useState({});

  const handleZoomIn = () => {
    // Fetching current height and width
    const height = imgRef.current.clientHeight;
    const width = imgRef.current.clientWidth;

    // Increase dimension(Zooming)
    const values = {
      height: height + 20,
      width: width + 20,
    };
    setCoords(values);
  };

  // Event handler callback zoom out
  const handleZoomOut = () => {
    // Fetching current height and width
    const values = {
      height: initialCoords.height,
      width: initialCoords.width,
    };
    setCoords(values);
  };

  useEffect(() => {
    if (imgRef && imgRef.current) {
      setCoords({
        width: imgRef.current.clientWidth,
        height: imgRef.current.clientHeight,
      });
      setInitialCoords({
        width: imgRef.current.clientWidth,
        height: imgRef.current.clientHeight,
      });
    }
  }, [imgRef]);

  return (
    <Modal
      visible={showModal}
      onClose={handleClose}
      type="medium"
      showCloseIcon={true}
      slideOnMobile
      isCentered
      padding="2rem"
      preventFocus
      className={fullWidthModal && "full-width-modal"}
    >
      {optionalInput !== undefined && optionalInput}
      {infoFields !== undefined && infoFields}
      <ModalHolder align="flex-start" justify="flex-start">
        <p className="mb-20">{primaryPhotoTitle}</p>
        <FlexContainer align="flex-start" justify="flex-start">
          <ImageContainer
            optionalPhotoUrl={optionalPhotoUrl}
            style={{ height: coords.height, width: coords.width }}
            ref={imgRef}
          >
            {pdf ? (
              <AllPagesPdf pdf={pdf} />
            ) : (
              <img
                className="primary-image"
                alt="driver-doc"
                src={modalContent}
              />
            )}
            {/* {(pdf || modalContent) && (
            <FlexContainer justify="flex-start" className="zoom-buttons">
              <Plus onClick={handleZoomIn} size={30} className="mr-10" />
              <Remove onClick={handleZoomOut} size={30} />
            </FlexContainer>
          )} */}
          </ImageContainer>
          {(pdf || modalContent) && (
            <DownloadLink src={pdf || modalContent}>
              <Download className="ml-10 mr-20" />
            </DownloadLink>
          )}
        </FlexContainer>
        {optionalPhotoUrl && (
          <div style={{ width: "50%" }}>
            <p className="mb-20">{optionalPhotoTitle}</p>
            <FlexContainer
              align="flex-start"
              justify="flex-start"
              style={{ width: "100%" }}
            >
              <img
                className="secondary-image"
                alt="driver-doc"
                src={optionalPhotoUrl}
              />
              <DownloadLink src={optionalPhotoUrl}>
                <Download className="ml-10 mr-20" />
              </DownloadLink>
            </FlexContainer>
          </div>
        )}
      </ModalHolder>
    </Modal>
  );
};

const ModalHolder = styled(FlexContainer)`
  & > div {
    width: 100%;
  }
  img {
    object-fit: contain;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  width: 80%;
  .zoom-buttons {
    position: absolute;
    right: 10px;
    top: 10px;
    i {
      background: ${variables.grey500};
      border-radius: 50%;
      cursor: pointer !important;
    }
  }
`;

export default DriverDocumentModal;
